export const CopyTextToClipboard = (copyText: string | undefined) => {
  navigator.clipboard.writeText(copyText ? copyText : "");
  return true;
};
